import { useNavigate } from 'react-router-dom';

const useCustomNavigate = () => {
  const navigate = useNavigate();

  const navigateToPage = (routeToPage, state) => {
    navigate(routeToPage, {
      state,
    });
  };

  return navigateToPage;
};

export default useCustomNavigate;
